import { FC } from 'react';
import { DotSpinner } from '@crono-one/design-system';

import PATH from 'crono-fe-common/constants/path';
import usePipedriveAuthCallback from 'hooks/services/pipedrive/usePipedriveAuthCallback';
import { useAuth } from 'context/auth';
import IntegrationType from 'crono-fe-common/types/enums/integrationType';
import useOauthCallbackCode from 'pages/connect/views/useOauthCallbackCode';
import storeOnboardingError from 'pages/connect/views/storeOnboardingError';

const PipedriveLoginHandler: FC = () => {
  const { refreshUser } = useAuth();
  const { mutate: pipedriveAuthCallback } = usePipedriveAuthCallback();

  useOauthCallbackCode({
    provider: 'Pipedrive',
    exchangeCode: pipedriveAuthCallback,
    buildVariables: (code) => ({ code }),
    missingCodePath: PATH.CONNECT,
    successPath: PATH.SETTINGS.INTEGRATIONS.MAIN,
    errorPath: PATH.CONNECT,
    onSuccess: refreshUser,
    onError: (error) => storeOnboardingError(error, IntegrationType.PIPEDRIVE),
  });

  return (
    <div className="flex h-full w-full items-center justify-center">
      <DotSpinner />
    </div>
  );
};

export default PipedriveLoginHandler;
